package music.jammers.client.shared.admin.presentation.viewmodel

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.admin_screen_songs_item_title
import limasoul.client.shared.generated.resources.admin_screen_users_item_title
import limasoul.client.shared.generated.resources.icon_musical_note
import limasoul.client.shared.generated.resources.icon_people
import music.jammers.client.shared.admin.presentation.model.SettingItem
import music.jammers.client.shared.component.BaseViewModel
import music.jammers.client.shared.component.update
import music.limasoul.client.shared.navigation.Router

class AdminViewModel(private val router: Router) : BaseViewModel() {

    internal val state: State<AdminSettingsPageState> get() = _state
    private val _state: MutableState<AdminSettingsPageState> = mutableStateOf(AdminSettingsPageState())

    internal fun onClickItem(ignored: SettingItem) {
        // ignored
    }

    internal fun onReady() {
        initScreenData()
    }

    internal fun onCloseButtonClicked() {
        router.back()
    }

    private fun initScreenData() {
        _state.update {
            copy(
                settingList = listOf(
                    SettingItem(
                        title = Res.string.admin_screen_songs_item_title,
                        icon = Res.drawable.icon_musical_note
                    ),
                    SettingItem(
                        title = Res.string.admin_screen_users_item_title,
                        icon = Res.drawable.icon_people
                    )
                )
            )
        }
    }
}